import { Location } from 'react-router-dom';

type Mapper = (value: string) => string;

export function navigateByQueryParam(location: Location, paramName: string, mapper: Mapper) {
  const urlSearchParams = new URLSearchParams(location.search);
  const paramValue = urlSearchParams.get(paramName);
  if (paramValue !== null) {
    const element = document.getElementById(mapper(paramValue));
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }, 100);
    }
  }
}
